module.exports = __webpack_public_path__ + "static/img/brand-first-bg-left.5c6dba38.png";